import { generateClient } from 'aws-amplify/api';
import { getTimeSheet } from "../graphql/customQueries";

const client = generateClient();

export default async (id) => {
    const {
        data: { getTimeSheet: timesheet },
    } = await client.graphql({
        query: getTimeSheet,
        variables: {
            id,
        },
    });
    return timesheet;
};